(() => {
  if (!document.querySelector('.jp-privacy-hero')) return;
  const body = document.querySelector('.shopify-policy__body');
  if (!body || body.dataset.jpOrganized) return;
  body.dataset.jpOrganized = 'true';
  const source = body.querySelector('.rte') || body;
  const nodes = Array.from(source.childNodes);
  if (!source.textContent.trim()) return;
  const layout = document.createElement('div'); layout.className = 'jp-policy-layout';
  const intro = document.createElement('aside'); intro.className = 'jp-policy-intro';
  const eyebrow = document.createElement('span'); eyebrow.className = 'jp-eyebrow'; eyebrow.textContent = 'POLÍTICA DE PRIVACIDADE';
  const heading = document.createElement('h2'); heading.textContent = 'Informação clara, do começo ao fim.';
  const note = document.createElement('p'); note.textContent = 'Abra os tópicos para consultar a política da loja.';
  intro.append(eyebrow, heading, note);
  const items = document.createElement('div'); items.className = 'jp-policy-items';
  let copy; let count = 0;
  function addSection(title) {
    const detail = document.createElement('details'); detail.className = 'jp-policy-item'; detail.open = count === 0;
    const summary = document.createElement('summary');
    const number = document.createElement('span'); number.className = 'jp-policy-number'; number.textContent = String(++count).padStart(2,'0');
    const label = document.createElement('span'); label.textContent = title;
    summary.append(number,label); copy = document.createElement('div'); copy.className = 'jp-policy-copy'; detail.append(summary,copy); items.append(detail);
  }
  for (const node of nodes) {
    if (node.nodeType === 1 && /^(H1|H2|H3)$/.test(node.tagName)) { addSection(node.textContent.trim() || 'Política de privacidade'); }
    else { if (!copy && (node.nodeType === 1 || node.textContent.trim())) addSection('Sobre esta política'); if (copy) copy.append(node); }
  }
  layout.append(intro,items); source.replaceChildren(layout);
})();
